/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChefsEntrepriseSiegeDoublonGridDto } from './ChefsEntrepriseSiegeDoublonGridDto';
import {
    ChefsEntrepriseSiegeDoublonGridDtoFromJSON,
    ChefsEntrepriseSiegeDoublonGridDtoFromJSONTyped,
    ChefsEntrepriseSiegeDoublonGridDtoToJSON,
} from './ChefsEntrepriseSiegeDoublonGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ChefsEntrepriseSiegeDoublonGridDtoPaginatedResults
 */
export interface ChefsEntrepriseSiegeDoublonGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ChefsEntrepriseSiegeDoublonGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ChefsEntrepriseSiegeDoublonGridDto>}
     * @memberof ChefsEntrepriseSiegeDoublonGridDtoPaginatedResults
     */
    results?: Array<ChefsEntrepriseSiegeDoublonGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ChefsEntrepriseSiegeDoublonGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ChefsEntrepriseSiegeDoublonGridDtoPaginatedResults interface.
 */
export function instanceOfChefsEntrepriseSiegeDoublonGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefsEntrepriseSiegeDoublonGridDtoPaginatedResultsFromJSON(json: any): ChefsEntrepriseSiegeDoublonGridDtoPaginatedResults {
    return ChefsEntrepriseSiegeDoublonGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ChefsEntrepriseSiegeDoublonGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefsEntrepriseSiegeDoublonGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ChefsEntrepriseSiegeDoublonGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ChefsEntrepriseSiegeDoublonGridDtoPaginatedResultsToJSON(value?: ChefsEntrepriseSiegeDoublonGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ChefsEntrepriseSiegeDoublonGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

